module.exports = require("npm:buffer@3.6.0/index.js");